// extracted by mini-css-extract-plugin
export var cardContainer = "_mi-0";
export var cardHeader = "_mi-2";
export var collapsedState = "_mi-3";
export var dragHandle = "_mi-5";
export var dragHandleIcon = "_mi-6";
export var dragging = "_mi-1";
export var titleArea = "_mi-4";